(function () {
  'use strict';

  if (window._videoModalInitialized) return;
  window._videoModalInitialized = true;

  var modal, scrollContainer, closeBtn, muteBtn, sheet, sheetHandleArea, sheetTabs, sheetContent, infoEl, modelEl, productsThumb, productsThumbImg, productsThumbBadge, backdrop, seekbarContainer, seekbarFill;
  var isMuted = true;
  var currentIndex = 0;
  var videos = [];
  var observer = null;
  var sheetIsOpen = false;
  var activeVideoEl = null;
  var seekbarRAF = null;
  var tapIconTimeout = null;
  var URL_PARAM = 'video';
  var urlPushed = false;
  var modalIsOpen = false;

  function createModal() {
    modal = document.createElement('div');
    modal.id = 'video-fullscreen-modal';
    modal.className = 'video-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', '動画再生');
    modal.hidden = true;

    modal.innerHTML =
      '<button class="video-modal__close" aria-label="閉じる">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<line x1="18" y1="6" x2="6" y2="18"></line>' +
          '<line x1="6" y1="6" x2="18" y2="18"></line>' +
        '</svg>' +
      '</button>' +
      '<div class="video-modal__scroll-container"></div>' +
      '<div class="video-modal__side-controls">' +
        '<button class="video-modal__side-btn video-modal__mute-btn" aria-label="ミュート切り替え">' +
          '<svg class="video-modal-icon--muted" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>' +
            '<line x1="23" y1="9" x2="17" y2="15"></line>' +
            '<line x1="17" y1="9" x2="23" y2="15"></line>' +
          '</svg>' +
          '<svg class="video-modal-icon--unmuted" style="display:none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>' +
            '<path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="video-modal__info">' +
        '<div class="video-modal__model"></div>' +
      '</div>' +
      '<div class="video-modal__sheet">' +
        '<div class="video-modal__sheet-handle-area">' +
          '<div class="video-modal__sheet-handle"></div>' +
        '</div>' +
        '<div class="video-modal__sheet-tabs"></div>' +
        '<div class="video-modal__sheet-content"></div>' +
      '</div>' +
      '<button class="video-modal__products-thumb" style="display:none" aria-label="商品を見る">' +
        '<img class="video-modal__products-thumb-img" alt="">' +
        '<span class="video-modal__products-thumb-badge"></span>' +
      '</button>' +
      '<div class="video-modal__seekbar-container">' +
        '<div class="video-modal__seekbar-track">' +
          '<div class="video-modal__seekbar-fill"></div>' +
        '</div>' +
      '</div>' +
      '<div class="video-modal__backdrop"></div>';

    document.body.appendChild(modal);

    scrollContainer = modal.querySelector('.video-modal__scroll-container');
    closeBtn = modal.querySelector('.video-modal__close');
    muteBtn = modal.querySelector('.video-modal__mute-btn');
    sheet = modal.querySelector('.video-modal__sheet');
    sheetHandleArea = modal.querySelector('.video-modal__sheet-handle-area');
    sheetTabs = modal.querySelector('.video-modal__sheet-tabs');
    sheetContent = modal.querySelector('.video-modal__sheet-content');
    modelEl = modal.querySelector('.video-modal__model');

    productsThumb = modal.querySelector('.video-modal__products-thumb');
    productsThumbImg = modal.querySelector('.video-modal__products-thumb-img');
    productsThumbBadge = modal.querySelector('.video-modal__products-thumb-badge');
    backdrop = modal.querySelector('.video-modal__backdrop');
    seekbarContainer = modal.querySelector('.video-modal__seekbar-container');
    seekbarFill = modal.querySelector('.video-modal__seekbar-fill');

    closeBtn.addEventListener('click', closeModal);
    muteBtn.addEventListener('click', toggleMute);
    productsThumb.addEventListener('click', function () { openSheet(); });
    backdrop.addEventListener('click', closeSheet);

    scrollContainer.addEventListener('click', function (e) {
      var item = e.target.closest('.video-modal__item');
      if (!item) return;
      var videoEl = item.querySelector('video');
      if (!videoEl) return;
      if (videoEl.paused) {
        videoEl._userPaused = false;
        videoEl.play().catch(function () {});
        showTapIcon(item, false);
      } else {
        videoEl._userPaused = true;
        videoEl.pause();
        showTapIcon(item, true);
      }
    });

    var isSeeking = false;
    var wasPlayingBeforeSeek = false;

    function seekTo(clientX) {
      if (!activeVideoEl || !activeVideoEl.duration) return;
      var rect = seekbarContainer.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      activeVideoEl.currentTime = pct * activeVideoEl.duration;
      seekbarFill.style.width = (pct * 100) + '%';
    }

    function onSeekStart(clientX) {
      if (!activeVideoEl || !activeVideoEl.duration) return;
      isSeeking = true;
      wasPlayingBeforeSeek = !activeVideoEl.paused;
      activeVideoEl.pause();
      seekbarContainer.classList.add('is-seeking');
      seekTo(clientX);
    }

    function onSeekMove(clientX) {
      if (!isSeeking) return;
      seekTo(clientX);
    }

    function onSeekEnd() {
      if (!isSeeking) return;
      isSeeking = false;
      seekbarContainer.classList.remove('is-seeking');
      if (wasPlayingBeforeSeek && activeVideoEl) {
        activeVideoEl._userPaused = false;
        activeVideoEl.play().catch(function () {});
      }
    }

    seekbarContainer.addEventListener('mousedown', function (e) {
      e.preventDefault();
      onSeekStart(e.clientX);
      function onMouseMove(e) { onSeekMove(e.clientX); }
      function onMouseUp() {
        onSeekEnd();
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    seekbarContainer.addEventListener('touchstart', function (e) {
      onSeekStart(e.touches[0].clientX);
      function onTouchMove(e) {
        e.preventDefault();
        onSeekMove(e.touches[0].clientX);
      }
      function onTouchEnd() {
        onSeekEnd();
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      }
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend', onTouchEnd);
    }, { passive: true });

    sheetTabs.addEventListener('click', function (e) {
      var tab = e.target.closest('.video-modal__sheet-tab');
      if (!tab) return;
      activateTab(tab.dataset.tabId);
      if (!sheetIsOpen) openSheet();
    });

    initSheetDrag();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  }

  function initSheetDrag() {
    var startY = 0;
    var startTranslateY = 0;
    var isDragging = false;

    function getTranslateY() {
      var style = window.getComputedStyle(sheet);
      var matrix = new DOMMatrix(style.transform);
      return matrix.m42;
    }

    function onDragStart(clientY) {
      isDragging = true;
      startY = clientY;
      startTranslateY = getTranslateY();
      sheet.style.transition = 'none';
    }

    function onDragMove(clientY) {
      if (!isDragging) return;
      var delta = clientY - startY;
      var newY = startTranslateY + delta;
      var sheetH = sheet.offsetHeight;
      var minY = 0;
      var maxY = sheetH - 56;
      var clampedY = Math.max(minY, Math.min(maxY, newY));

      // On desktop, account for translateX(-50%)
      if (window.innerWidth >= 768) {
        sheet.style.transform = 'translateX(-50%) translateY(' + clampedY + 'px)';
      } else {
        sheet.style.transform = 'translateY(' + clampedY + 'px)';
      }
    }

    function onDragEnd(clientY) {
      if (!isDragging) return;
      isDragging = false;
      sheet.style.transition = '';
      sheet.style.transform = '';
      var delta = clientY - startY;
      if (delta > 60) {
        closeSheet();
      } else if (delta < -60) {
        openSheet();
      } else {
        if (sheetIsOpen) openSheet(); else closeSheet();
      }
    }

    function onTouchMove(e) { onDragMove(e.touches[0].clientY); }
    function onTouchEnd(e) {
      onDragEnd(e.changedTouches[0].clientY);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    }

    function onMouseMove(e) { onDragMove(e.clientY); }
    function onMouseUp(e) {
      onDragEnd(e.clientY);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    sheetHandleArea.addEventListener('touchstart', function (e) {
      onDragStart(e.touches[0].clientY);
      document.addEventListener('touchmove', onTouchMove, { passive: true });
      document.addEventListener('touchend', onTouchEnd);
    }, { passive: true });

    sheetHandleArea.addEventListener('mousedown', function (e) {
      onDragStart(e.clientY);
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });
  }

  function openModal(sectionId, startIndex, options) {
    var dataScript = document.getElementById('video-modal-data-' + sectionId);
    if (!dataScript) return;

    try {
      videos = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    if (!videos.length) return;

    isMuted = true;
    currentIndex = startIndex || 0;

    if (!(options && options.skipUrlPush)) {
      pushVideoUrl(videos[currentIndex] && videos[currentIndex].handle);
    }
    modalIsOpen = true;

    buildVideoItems();

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('video-modal-open');

    // Wait for layout to complete before scrolling and observing
    requestAnimationFrame(function () {
      var items = scrollContainer.querySelectorAll('.video-modal__item');
      if (items[currentIndex]) {
        scrollContainer.scrollTo({ top: items[currentIndex].offsetTop, behavior: 'instant' });
      }
      setupObserver();
      loadVideoSources(currentIndex);
      updateUI(currentIndex);
      closeBtn.focus();

      // Explicitly play the current video since IntersectionObserver fires asynchronously
      var currentItem = items[currentIndex];
      if (currentItem) {
        var videoEl = currentItem.querySelector('video');
        if (videoEl) {
          videoEl.muted = isMuted;
          videoEl.play().catch(function () {});
          attachSeekbar(videoEl);
          trackViewStart(currentIndex);
        }
      }
    });
  }

  function loadVideoSources(index) {
    var items = scrollContainer.querySelectorAll('.video-modal__item');
    // Load current ± 1
    [index - 1, index, index + 1].forEach(function (i) {
      if (i < 0 || i >= videos.length) return;
      var item = items[i];
      if (!item || item.dataset.sourcesLoaded) return;
      item.dataset.sourcesLoaded = 'true';

      var videoEl = item.querySelector('video');
      var videoData = videos[i];
      if (!videoEl || !videoData) return;

      if (videoData.sources && videoData.sources.length > 0) {
        videoData.sources.forEach(function (src) {
          var source = document.createElement('source');
          source.src = src.url;
          if (src.mimeType) source.type = src.mimeType;
          videoEl.appendChild(source);
        });
        videoEl.load();
      } else if (videoData.src) {
        videoEl.src = videoData.src;
        videoEl.load();
      }
    });
  }

  function buildVideoItems() {
    scrollContainer.innerHTML = '';

    videos.forEach(function (videoData, index) {
      var item = document.createElement('div');
      item.className = 'video-modal__item';
      item.dataset.index = index;

      var videoEl = document.createElement('video');
      videoEl.setAttribute('playsinline', '');
      videoEl.setAttribute('loop', '');
      videoEl.muted = true;
      videoEl.playsInline = true;
      videoEl.loop = true;
      // Sources are loaded lazily via loadVideoSources()

      item.appendChild(videoEl);
      scrollContainer.appendChild(item);
    });
  }

  function trackViewStart(index) {
    if (!window.VideoAnalytics) return;
    window.VideoAnalytics.trackViewStart(videos[index], 'modal');
  }

  function trackViewEnd(index) {
    if (!window.VideoAnalytics) return;
    window.VideoAnalytics.trackViewEnd(videos[index], 'modal');
  }

  function setupObserver() {
    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = entry.target;
        var index = parseInt(item.dataset.index, 10);
        var videoEl = item.querySelector('video');
        if (!videoEl) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          currentIndex = index;
          loadVideoSources(index);
          videoEl.muted = isMuted;
          videoEl._userPaused = false;
          videoEl.play().catch(function () {});
          updateUI(index);
          attachSeekbar(videoEl);
          trackViewStart(index);
          replaceVideoUrl(videos[index] && videos[index].handle);
        } else {
          videoEl.pause();
          videoEl.currentTime = 0;
          videoEl._userPaused = false;
          trackViewEnd(index);
        }
      });
    }, { threshold: 0.7 });

    scrollContainer.querySelectorAll('.video-modal__item').forEach(function (item) {
      observer.observe(item);
    });
  }

  function updateUI(index) {
    var videoData = videos[index];
    if (!videoData) return;

    // Model info overlay
    modelEl.innerHTML = '';
    if (videoData.model) {
      var avatar = videoData.model.avatarUrl
        ? '<img class="video-modal__model-avatar" src="' + videoData.model.avatarUrl + '" alt="' + escapeHtml(videoData.model.name || '') + '" loading="lazy">'
        : '<div class="video-modal__model-avatar-placeholder"></div>';
      modelEl.innerHTML = avatar + '<span class="video-modal__model-name">' + escapeHtml(videoData.model.name || '') + '</span>';
    }

    // Products thumbnail
    if (videoData.products && videoData.products.length > 0) {
      productsThumbImg.src = videoData.products[0].imageUrl || '';
      productsThumbBadge.textContent = videoData.products.length;
      productsThumb.style.display = '';
    } else {
      productsThumb.style.display = 'none';
    }

    buildSheetContent(videoData);
    closeSheet();
  }

  function buildSheetContent(videoData) {
    var products = videoData.products || [];
    var model = videoData.model;

    var tabsHTML = '';
    var contentHTML = '';

    if (products.length > 0) {
      tabsHTML += '<button class="video-modal__sheet-tab is-active" data-tab-id="items">着用アイテム (' + products.length + ')</button>';

      var productItems = products.map(function (p) {
        var img = p.imageUrl
          ? '<img class="video-modal__product-img" src="' + p.imageUrl + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy">'
          : '<div class="video-modal__product-img"></div>';
        var comparePrice = p.compareAtPrice
          ? '<span class="video-modal__product-compare-price">' + escapeHtml(p.compareAtPrice) + '</span>'
          : '';
        return '<a href="' + escapeHtml(p.url || '#') + '" class="video-modal__product-item">' +
          img +
          '<div class="video-modal__product-info">' +
            (p.brand ? '<div class="video-modal__product-brand">' + escapeHtml(p.brand) + '</div>' : '') +
            '<div class="video-modal__product-title">' + escapeHtml(p.title || '') + '</div>' +
            '<div><span class="video-modal__product-price">' + escapeHtml(p.price || '') + '</span>' + comparePrice + '</div>' +
          '</div>' +
        '</a>';
      }).join('');

      contentHTML += '<div class="video-modal__sheet-panel is-active" data-panel-id="items">' + productItems + '</div>';
    }

    if (model) {
      var isFirst = products.length === 0;
      tabsHTML += '<button class="video-modal__sheet-tab' + (isFirst ? ' is-active' : '') + '" data-tab-id="model">モデル情報</button>';

      var modelAvatar = model.avatarUrl
        ? '<img class="video-modal__model-detail-avatar" src="' + model.avatarUrl + '" alt="' + escapeHtml(model.name || '') + '" loading="lazy">'
        : '<div class="video-modal__model-detail-avatar-placeholder"></div>';
      var igLink = model.instagram
        ? '<a href="https://instagram.com/' + escapeHtml(model.instagram) + '" class="video-modal__model-detail-ig" target="_blank" rel="noopener">@' + escapeHtml(model.instagram) + '</a>'
        : '';

      contentHTML += '<div class="video-modal__sheet-panel' + (isFirst ? ' is-active' : '') + '" data-panel-id="model">' +
        '<div class="video-modal__model-detail">' +
          modelAvatar +
          '<div>' +
            '<div class="video-modal__model-detail-name">' + escapeHtml(model.name || '') + '</div>' +
            (model.height ? '<div class="video-modal__model-detail-height">身長: ' + escapeHtml(model.height) + '</div>' : '') +
            igLink +
          '</div>' +
        '</div>' +
      '</div>';
    }

    sheetTabs.innerHTML = tabsHTML;
    sheetContent.innerHTML = contentHTML;
  }

  function activateTab(tabId) {
    sheetTabs.querySelectorAll('.video-modal__sheet-tab').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.dataset.tabId === tabId);
    });
    sheetContent.querySelectorAll('.video-modal__sheet-panel').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.panelId === tabId);
    });
  }

  function attachSeekbar(videoEl) {
    if (seekbarRAF) cancelAnimationFrame(seekbarRAF);
    activeVideoEl = videoEl;

    function tick() {
      if (activeVideoEl && activeVideoEl.duration) {
        seekbarFill.style.width = (activeVideoEl.currentTime / activeVideoEl.duration * 100) + '%';
      }
      seekbarRAF = requestAnimationFrame(tick);
    }
    seekbarRAF = requestAnimationFrame(tick);
  }

  function openSheet() {
    sheetIsOpen = true;
    sheet.classList.add('is-open');
    backdrop.classList.add('is-visible');
  }

  function closeSheet() {
    sheetIsOpen = false;
    sheet.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
  }

  function toggleMute() {
    isMuted = !isMuted;
    scrollContainer.querySelectorAll('video').forEach(function (v) {
      v.muted = isMuted;
    });
    var mutedIcon = muteBtn.querySelector('.video-modal-icon--muted');
    var unmutedIcon = muteBtn.querySelector('.video-modal-icon--unmuted');
    if (mutedIcon) mutedIcon.style.display = isMuted ? '' : 'none';
    if (unmutedIcon) unmutedIcon.style.display = isMuted ? 'none' : '';
  }

  /**
   * ユーザー操作による閉じる。URLを戻し、その popstate で teardown が走る。
   * 共有URLで直接開いた場合は履歴を積んでいないため、その場で teardown する。
   */
  function closeModal() {
    if (urlPushed) {
      popVideoUrl();
      return;
    }
    teardownModal();
  }

  function teardownModal() {
    modalIsOpen = false;
    if (window.VideoAnalytics) window.VideoAnalytics.reset();
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (seekbarRAF) {
      cancelAnimationFrame(seekbarRAF);
      seekbarRAF = null;
    }
    activeVideoEl = null;
    seekbarFill.style.width = '0%';
    scrollContainer.querySelectorAll('video').forEach(function (v) {
      v.pause();
    });
    scrollContainer.innerHTML = '';
    modal.hidden = true;
    document.body.style.overflow = '';
    document.body.classList.remove('video-modal-open');
    sheetIsOpen = false;
    sheet.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
  }

  function showTapIcon(item, isPause) {
    var existing = item.querySelector('.video-modal__tap-icon');
    if (existing) existing.remove();
    if (tapIconTimeout) clearTimeout(tapIconTimeout);

    var icon = document.createElement('div');
    icon.className = 'video-modal__tap-icon';
    icon.innerHTML = isPause
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>';
    item.appendChild(icon);

    tapIconTimeout = setTimeout(function () {
      icon.classList.add('video-modal__tap-icon--fade');
      setTimeout(function () { if (icon.parentNode) icon.remove(); }, 300);
    }, 600);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // --- URL連携 ---------------------------------------------------------
  // モーダルを開くと ?video=<handle> を履歴に積む。
  // URLの共有と、戻るボタンでモーダルだけ閉じる挙動のため。
  // GA4のpage_viewは意図的に送っていない。開閉のたびに飛んで
  // 二重計上になり、視聴回数は video_view イベント側で取れているため。

  function getVideoHandleFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get(URL_PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  /** handle からモーダルデータを逆引きする。ページ内の全データを走査する。 */
  function findVideoByHandle(handle) {
    var scripts = document.querySelectorAll('[id^="video-modal-data-"]');

    for (var i = 0; i < scripts.length; i++) {
      var list;
      try {
        list = JSON.parse(scripts[i].textContent);
      } catch (e) {
        continue;
      }

      for (var j = 0; j < list.length; j++) {
        if (list[j].handle && list[j].handle === handle) {
          return {
            sectionId: scripts[i].id.replace('video-modal-data-', ''),
            index: j
          };
        }
      }
    }
    return null;
  }

  function pushVideoUrl(handle) {
    if (!handle || !window.history || !window.history.pushState) return;

    var url = new URL(window.location.href);
    url.searchParams.set(URL_PARAM, handle);
    window.history.pushState({ videoModal: true }, '', url.toString());
    urlPushed = true;
  }

  /**
   * スワイプでの遷移はURLだけ差し替える。
   * pushState だと動画ごとに履歴が積まれ、戻るボタンで
   * 見てきた動画を1つずつ遡ることになるため。
   */
  function replaceVideoUrl(handle) {
    if (!handle || !modalIsOpen || !window.history || !window.history.replaceState) return;

    var url = new URL(window.location.href);
    if (url.searchParams.get(URL_PARAM) === handle) return;

    url.searchParams.set(URL_PARAM, handle);
    window.history.replaceState(window.history.state, '', url.toString());
  }

  /** 開いたときに積んだ履歴を戻す。popstate 経由の場合は既に戻っているので何もしない。 */
  function popVideoUrl() {
    if (!urlPushed) return;
    urlPushed = false;
    window.history.back();
  }

  function restoreFromUrl() {
    var handle = getVideoHandleFromUrl();
    if (!handle) return;

    var found = findVideoByHandle(handle);
    if (!found) return;

    // 共有URLで直接開いた場合、この状態が履歴の起点になる。
    // pushState せずに開き、戻るボタンでは前のページに戻す。
    openModal(found.sectionId, found.index, { skipUrlPush: true });
  }

  // Global trigger handler
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-video-modal-trigger]');
    if (!trigger) return;
    e.preventDefault();
    var sectionId = trigger.dataset.videoModalSection;
    var index = parseInt(trigger.dataset.videoModalIndex || '0', 10);
    openModal(sectionId, index);
  });

  // 戻る/進むでモーダルの開閉を同期する。
  // モーダルを開いたまま戻ると、サイトを離脱せずモーダルだけ閉じる。
  window.addEventListener('popstate', function () {
    urlPushed = false;

    var handle = getVideoHandleFromUrl();

    if (!handle) {
      if (modalIsOpen) teardownModal();
      return;
    }

    // 進むで動画URLに戻ってきた場合
    if (!modalIsOpen) {
      var found = findVideoByHandle(handle);
      if (found) openModal(found.sectionId, found.index, { skipUrlPush: true });
    }
  });

  // Init
  function init() {
    createModal();
    window.openVideoModal = openModal;
    restoreFromUrl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
